import axios from 'axios'
import Cookies from 'js-cookie'
import { API_KEY_LINX } from 'src/util/config'
import { AutoCompletesLinxResponse } from './dtos/auto-completes-response'
import { origin } from 'src/util/Linx'

type ProductSearchQuery = {
  search: string
}

type QueryParams = {
  prefix: string
  resultsQueries: string
  resultsProducts: string
  deviceId?: string
}

export const autoCompletesLinx = async ({ search }: ProductSearchQuery) => {
  const deviceId = Cookies.get('nav_id')

  const queryParams: QueryParams = {
    prefix: encodeURIComponent(search),
    resultsQueries: '7',
    resultsProducts: '0',
    deviceId,
  }

  const completeUrl = new URLSearchParams(queryParams)

  const { data } = await axios.get<AutoCompletesLinxResponse>(
    `https://api.linximpulse.com/engage/search/v3/autocompletes?apiKey=${API_KEY_LINX}&${completeUrl}`,
    {
      headers: { origin: origin() },
    }
  )

  return data
}
